var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.356,
    height: 20.246,
    viewBox: "0 0 26.356 20.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "analytics",
    d: "M1106.526,852.007l-2.125,4.984-5.713-13.535a1.72,1.72,0,0,0-3.036.035l-3.2,7.524h-3.3a1.613,1.613,0,0,0,0,3.226h4.4a1.572,1.572,0,0,0,1.474-.993l2.126-4.984,5.712,13.535a1.606,1.606,0,0,0,1.48,1.008,1.586,1.586,0,0,0,1.47-.994l3.22-7.573h3.248a1.61,1.61,0,0,0,1.61-1.6,1.505,1.505,0,0,0-1.4-1.619,1.317,1.317,0,0,0-.14,0H1108A1.6,1.6,0,0,0,1106.526,852.007Z",
    transform: "translate(-1087.541 -842.561)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analyticsIcon.0f5ca16f5e8c61cdfc5b3cb35b2334b7.svg";
export { ForwardRef as ReactComponent };